exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table thead th[data-v-6891c3c0] {\n  vertical-align: top;\n}", ""]);

// exports
